<script lang="ts" setup>
withDefaults(
    defineProps<{
        stroke?: string;
        border?: string;
        hidePattern?: boolean;
    }>(),
    {
        stroke: "stroke-gray-900/[7.5%] dark:stroke-white/[7.5%]",
        border: "border border-dashed border-gray-400 dark:border-gray-500/75",
    },
);
</script>

<template>
    <div :class="[stroke, border]" class="relative">
        <svg
            class="absolute inset-0 h-full w-full"
            fill="none"
            v-if="!hidePattern"
        >
            <defs>
                <pattern
                    id="pattern-5c1e4f0e-62d5-498b-8ff0-cf77bb448c8e"
                    height="10"
                    patternUnits="userSpaceOnUse"
                    width="10"
                    x="0"
                    y="0"
                >
                    <path d="M-3 13 15-5M-5 5l18-18M-1 21 17 3" />
                </pattern>
            </defs>
            <rect
                fill="url(#pattern-5c1e4f0e-62d5-498b-8ff0-cf77bb448c8e)"
                height="100%"
                stroke="none"
                width="100%"
            />
        </svg>
        <slot />
    </div>
</template>
